import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function SeasonalTrendsPage() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: import.meta.env.VITE_SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Vigorbuy Spreadsheet Seasonal Trends', item: import.meta.env.VITE_SITE_URL + '/blog/vigorbuy-spreadsheet-seasonal-trends' },
    ],
  };
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org', '@type': 'Article',
          headline: 'Seasonal Shopping Guide 2026: What is Trending on Vigorbuy Spreadsheet Right Now',
          description: 'Stay ahead of seasonal fashion trends with this curated overview of what products are hot on the Vigorbuy Spreadsheet right now.',
          author: { '@type': 'Organization', name: 'Vigorbuy Spreadsheet Hub' },
          datePublished: '2026-07-15', dateModified: '2026-07-22',
          publisher: { '@type': 'Organization', name: 'Vigorbuy Spreadsheet Hub', url: import.meta.env.VITE_SITE_URL },
          mainEntityOfPage: { '@type': 'WebPage', '@id': import.meta.env.VITE_SITE_URL + '/blog/vigorbuy-spreadsheet-seasonal-trends' },
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
        <article className="max-w-3xl mx-auto px-4 md:px-6">
          <nav className="mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
              <li><Link to="/" className="hover:text-primary-500 transition-colors">Home</Link></li>
              <li><span className="text-foreground-300">/</span></li>
              <li><span className="text-foreground-700 font-medium">Seasonal Trends</span></li>
            </ol>
          </nav>
          <header className="mb-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">Trends</span>
              <time className="text-xs text-foreground-400">July 15, 2026</time>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-4">
              Seasonal Shopping Guide: What is Trending on Vigorbuy Spreadsheet
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Fashion moves fast, and staying ahead of seasonal trends requires access to timely, curated product
              information. The Vigorbuy Spreadsheet serves as a real-time pulse on what is hot across every category,
              with community activity levels providing natural indicators of emerging trends.
            </p>
          </header>
          <div className="prose-custom space-y-8">
            <section>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">Summer 2026: What Is Moving Fast</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                As we move through summer 2026, several clear trend patterns have emerged from Vigorbuy Spreadsheet
                activity data. Lightweight linen and cotton blend pieces are dominating the T-Shirts and Pants categories,
                with natural earth tones and soft pastels leading color preferences. The community is gravitating toward
                breathable fabrics and relaxed silhouettes — a practical response to rising global temperatures and a
                broader shift toward comfort-focused fashion.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                Accessories are showing a strong shift toward functional style. Cross-body bags with multiple compartments,
                UV-protective sunglasses with interchangeable lenses, and minimalist waterproof watches are all seeing
                elevated community engagement and repeat purchase rates. This blend of utility and aesthetics reflects
                a maturing consumer mindset that refuses to compromise on either front.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                The footwear trend cycle continues its retro-meets-modern evolution. Classic runner silhouettes from the
                1990s and early 2000s remain incredibly popular, but with contemporary material upgrades and refreshed
                color palettes. The Vigorbuy Spreadsheet community has been particularly active in documenting QC photos
                of these heritage-inspired designs, helping buyers distinguish between faithful reproductions and lower
                quality imitations.
              </p>
            </section>
            <div className="p-6 md:p-8 rounded-2xl bg-primary-50 border border-primary-200/70 text-center">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">Stay Ahead of Trends</h3>
              <p className="text-sm text-foreground-600 mb-5 max-w-lg mx-auto">Explore trending products across all Vigorbuy Spreadsheet categories.</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
                Explore Trends <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}